module.exports = __webpack_public_path__ + "img/family.4651f18b.png";